import { useTranslation } from "react-i18next";
import { heroData } from "@/mocks/home";

export default function HeroSection() {
  const { t } = useTranslation("home");

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={heroData.backgroundImage}
        alt="HVAC systems"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 animate-fade-in-up">
          {t("hero.title")}
        </h1>
        <div className="w-20 h-1 bg-white/80 mb-6" />
        <p className="text-base md:text-lg text-white/90 max-w-3xl leading-relaxed animate-fade-in-up">
          {t("hero.subtitle")}
        </p>
      </div>
    </section>
  );
}